import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { CheckCircle2Icon, AlertTriangleIcon } from 'lucide-react';
export function ArticleBody() {
  return <article className="space-y-12 mb-16" data-id="element-7">
      {/* PROBLEM */}
      <FadeIn data-id="element-8">
        <div className="bg-red-50 border-l-4 border-[#CC0000] p-6 rounded-r-xl" data-id="element-9">
          <p className="text-lg md:text-xl font-bold text-[#CC0000] leading-relaxed" data-id="element-10">
            Window quotes can vary by thousands depending on your zip code — but
            most homeowners never see the real price range.
          </p>
        </div>
      </FadeIn>

      {/* CONSEQUENCE */}
      <FadeIn data-id="element-11">
        <p className="text-xl md:text-2xl font-semibold text-[#111] text-center leading-relaxed max-w-3xl mx-auto" data-id="element-12">
          That means many people end up overpaying without even knowing it.
        </p>
      </FadeIn>

      {/* CTA */}
      <FadeIn data-id="element-13">
        <div className="flex justify-center" data-id="element-14">
          <CTAButton data-id="element-15">See My Local Rates</CTAButton>
        </div>
      </FadeIn>

      {/* SOLUTION */}
      <FadeIn data-id="element-16">
        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6 md:p-8 text-center" data-id="element-17">
          <p className="text-lg md:text-xl text-[#111] font-medium leading-relaxed" data-id="element-18">
            This simple tool lets you check real prices based on your location
            in under a minute.
          </p>
        </div>
      </FadeIn>

      {/* EXPECTATION SETTING */}
      <FadeIn data-id="element-19">
        <div className="bg-blue-50 border border-blue-200 rounded-2xl p-6 md:p-8" data-id="element-20">
          <p className="text-base md:text-lg text-[#1A6FD4] font-semibold mb-2" data-id="element-21">
            Here's what happens next:
          </p>
          <p className="text-lg text-[#111] leading-relaxed" data-id="element-22">
            On the next page, you'll enter your zip code and answer a few quick
            questions to see your local pricing options.
          </p>
        </div>
      </FadeIn>

      {/* BENEFITS */}
      <FadeIn data-id="element-23">
        <div className="max-w-2xl mx-auto" data-id="element-24">
          <div className="space-y-4" data-id="element-25">
            {['See real local pricing', 'Compare multiple options', 'Avoid overpaying', 'Takes less than 60 seconds'].map((benefit, i) => <div key={i} className="flex items-center gap-3 bg-white border border-gray-100 rounded-xl p-4 shadow-sm" data-id="element-26">
                <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-27" />
                <span className="text-lg font-medium text-[#111]" data-id="element-28">
                  {benefit}
                </span>
              </div>)}
          </div>
        </div>
      </FadeIn>

      {/* URGENCY */}
      <FadeIn data-id="element-29">
        <div className="flex items-center justify-center gap-2 bg-yellow-50 border border-yellow-300 rounded-xl p-4" data-id="element-30">
          <AlertTriangleIcon className="w-5 h-5 text-yellow-600 flex-shrink-0" data-id="element-31" />
          <p className="text-base font-semibold text-yellow-800" data-id="element-32">
            Due to high demand, availability may vary by location.
          </p>
        </div>
      </FadeIn>

      {/* CTA */}
      <FadeIn data-id="element-33">
        <div className="flex justify-center" data-id="element-34">
          <CTAButton data-id="element-35">Start My Price Check</CTAButton>
        </div>
      </FadeIn>
    </article>;
}